import React, { memo } from 'react'
import { withRouter, RouteComponentProps } from "react-router-dom";

import { ICountry, ITour, withAppStoreValue } from "../../../store";
import { EHeaderStateActionTypes, withHeaderStoreValue, HeaderDispatchAction } from "../store";

interface IToggleSearchButtonCoreHeaderStoreProps {
    searchShow: boolean
    dispatch: HeaderDispatchAction
}

interface IToggleSearchButtonCoreAppStoreProps {
    tour: ITour
}

const ToggleSearchButtonCore = memo(withRouter((props: RouteComponentProps & IToggleSearchButtonCoreHeaderStoreProps & IToggleSearchButtonCoreAppStoreProps) => {
    const { location: { state: { country = undefined } = {} }, searchShow, dispatch, tour } = props
    const actualCountry = tour && tour.country || country as ICountry
    if (!actualCountry) return null

    const toggleSearch = () => dispatch({ type: EHeaderStateActionTypes.UpdateSearchShow, value: !searchShow})
    return (
        <button className="search-toggle" onClick={toggleSearch}>
            <img src="/images/icons/icon-search.png" className="Search_icon" alt="Search" />
        </button>
    )
}))

export const ToggleSearchButton = withAppStoreValue(withHeaderStoreValue<IToggleSearchButtonCoreHeaderStoreProps & IToggleSearchButtonCoreAppStoreProps>(ToggleSearchButtonCore, ['dispatch', 'searchShow']), ['tour'])